var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.authenticationRequired
        ? _c("authentication", {
            attrs: {
              "test-mode": _vm.contract.TestMode,
              moving: true,
              "redirect-url": "/NewContract/Contract?moving=True",
              "show-authentication": _vm.showAuthentication
            },
            on: { authenticate: _vm.authenticate }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.authenticationRequired
        ? _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-10",
                          attrs: {
                            "label-cols-sm": "12",
                            "label-cols-md": "12",
                            "label-cols-lg": "12"
                          }
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "font-weight-bold pt-0",
                              attrs: { for: "customerName" }
                            },
                            [_vm._v(_vm._s(_vm.$t("Nimi")))]
                          ),
                          _vm._v(" "),
                          _vm.contract.CustomerType ==
                          _vm.CustomerTypeEnum.CONSUMER
                            ? _c("b-form-input", {
                                attrs: {
                                  id: "customerName",
                                  type: "text",
                                  value: _vm.moveOutName
                                    ? _vm.moveOutName
                                    : _vm.moveOutCustomerName,
                                  name: "moveOutName",
                                  maxlength: "100",
                                  disabled: ""
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.contract.CustomerType ==
                          _vm.CustomerTypeEnum.COMPANY
                            ? _c("b-form-input", {
                                attrs: {
                                  id: "customerName",
                                  type: "text",
                                  value: _vm.moveOutName
                                    ? _vm.moveOutName
                                    : _vm.moveOutCompanyName,
                                  name: "moveOutName",
                                  maxlength: "100",
                                  disabled: ""
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "validated-form-group",
                        {
                          attrs: {
                            "validation-errors": _vm.validationErrors,
                            "validation-id": "moContracts"
                          }
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-10",
                              attrs: {
                                "label-cols-sm": "12",
                                "label-cols-md": "12",
                                "label-cols-lg": "12"
                              }
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "font-weight-bold pt-0" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Valitse päätettävät sopimukset")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.moveOutContracts == null ||
                              _vm.moveOutContracts.length == 0
                                ? _c("div", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("Ei sopimuksia")) +
                                        "\n                        "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.moveOutContracts, function(
                                moveOutContract
                              ) {
                                return _c(
                                  "div",
                                  _vm._l(moveOutContract.Utilities, function(
                                    utility
                                  ) {
                                    return _c("div", [
                                      _c(
                                        "label",
                                        { staticClass: "checkbox-inline" },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.selectedMoveOutContracts,
                                                expression:
                                                  "selectedMoveOutContracts"
                                              }
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id:
                                                utility.MeteringPointCode +
                                                "|" +
                                                utility.UtilityTypeId
                                            },
                                            domProps: {
                                              value:
                                                utility.MeteringPointCode +
                                                "|" +
                                                utility.UtilityTypeId,
                                              checked: Array.isArray(
                                                _vm.selectedMoveOutContracts
                                              )
                                                ? _vm._i(
                                                    _vm.selectedMoveOutContracts,
                                                    utility.MeteringPointCode +
                                                      "|" +
                                                      utility.UtilityTypeId
                                                  ) > -1
                                                : _vm.selectedMoveOutContracts
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.selectedMoveOutContracts,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v =
                                                      utility.MeteringPointCode +
                                                      "|" +
                                                      utility.UtilityTypeId,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      (_vm.selectedMoveOutContracts = $$a.concat(
                                                        [$$v]
                                                      ))
                                                  } else {
                                                    $$i > -1 &&
                                                      (_vm.selectedMoveOutContracts = $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        ))
                                                  }
                                                } else {
                                                  _vm.selectedMoveOutContracts = $$c
                                                }
                                              }
                                            }
                                          }),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                moveOutContract.MeteringPointAddress
                                              ) +
                                              " (" +
                                              _vm._s(
                                                utility.ExternalMeteringPointCode
                                              ) +
                                              " - " +
                                              _vm._s(
                                                _vm.UtilityTypeFormat.toString(
                                                  utility.UtilityTypeId
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                          utility.UtilityTypeId == 1
                                            ? _c("span", [
                                                utility.SourceCompanyCode ==
                                                "PKSV"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                            , " +
                                                          _vm._s(
                                                            _vm.contractTypeString(
                                                              2
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                utility.SourceCompanyCode ==
                                                "PKSM"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                                            , " +
                                                          _vm._s(
                                                            _vm.contractTypeString(
                                                              1
                                                            )
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ])
                                            : _vm._e(),
                                          _vm._v(
                                            ")\n                                "
                                          )
                                        ]
                                      )
                                    ])
                                  }),
                                  0
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "validated-form-group",
                      {
                        attrs: {
                          "validation-id": "movingDate",
                          "validation-errors": _vm.validationErrors
                        }
                      },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticClass: "mb-10",
                            attrs: {
                              "label-cols-sm": "12",
                              "label-cols-md": "12",
                              "label-cols-lg": "12"
                            }
                          },
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "font-weight-bold pt-0",
                                      attrs: { for: "movingDate-datepicker" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Valitse sopimusten päättymispäivämäärä"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { xs: "12", sm: "12", md: "4" } },
                                  [
                                    _c("b-form-datepicker", {
                                      directives: [
                                        {
                                          name: "new-contract-value",
                                          rawName: "v-new-contract-value"
                                        }
                                      ],
                                      staticClass: "mb-2",
                                      attrs: {
                                        id: "movingDate-datepicker",
                                        placeholder: "pp.kk.vvvv",
                                        "start-weekday": "1",
                                        name: "MovingDate",
                                        "date-format-options": {
                                          day: "numeric",
                                          month: "numeric",
                                          year: "numeric"
                                        },
                                        "date-disabled-fn": _vm.disableDates,
                                        min: _vm.minDate,
                                        locale: _vm.datePickerlanguage,
                                        "hide-header": true,
                                        "label-help": "",
                                        "no-highlight-today": ""
                                      },
                                      model: {
                                        value: _vm.movingDate,
                                        callback: function($$v) {
                                          _vm.movingDate = $$v
                                        },
                                        expression: "movingDate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }